// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-form { 
    width: 100%;
    max-width: 650px;
    margin: 0 auto;
}
.registration-form h2 {
    text-align: center;
}
.registration-form .instructions {
    font-size: 16px;
    line-height: 1.7em;
    text-align: center;
    padding: 20px;
}
.registration-form .base-error {
    text-align: center;
    color: var(--danger-color-main);
    padding: 10px;
}

.registration-form .field-wrapper {
    padding: 10px;
}
.registration-form .submit {
    text-align: center;
}

`, "",{"version":3,"sources":["webpack://./client/components/authentication/RegistrationForm.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".registration-form { \n    width: 100%;\n    max-width: 650px;\n    margin: 0 auto;\n}\n.registration-form h2 {\n    text-align: center;\n}\n.registration-form .instructions {\n    font-size: 16px;\n    line-height: 1.7em;\n    text-align: center;\n    padding: 20px;\n}\n.registration-form .base-error {\n    text-align: center;\n    color: var(--danger-color-main);\n    padding: 10px;\n}\n\n.registration-form .field-wrapper {\n    padding: 10px;\n}\n.registration-form .submit {\n    text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
